import angular from 'angular';

import DownloadPageComponent from './download-page-component';
import { DownloadPageController } from './download-page-controller';

export default angular
  .module('downalod-page', [])
  .controller('DownloadPageController', DownloadPageController)
  .component('downloadPage', DownloadPageComponent);



// WEBPACK FOOTER //
// ./src/modules/download-report-page/components/download-page/download-page-module.js